<template>
  <div>
    <section class="main-content templates-container">
      <alert />
      <div class="grid-x grid-margin-x">
        <div class="cell sidebar large-3 select-client" v-if="!isAllSelected">
          <client-list
            v-on:ondelete="onDeleteClient"
            v-on:show-params="showReplacedText"
          />
        </div>
        <div class="cell large-3 select-client-button" v-else>
          <hcc-button @click="openReports">
            {{ $t('templates.clients')}}
          </hcc-button>
        </div>
        <div v-show="step === 1" class="cell large-9 select-table">
          <div class="grid-x">
            <div class="search-container">
              <div class="action-buttons">
                <upload-file-csv v-show="showCsv" @load="getNumbers" />
                <button-filter
                  channelType="whatsapp"
                  :display="showDisplay"
                  v-on:change="onFiltersChanged"
                />
              </div>
            </div>
          </div>
          <filters
            :display="showDisplay"
            :channel="currentChannelId"
            channelType="whatsapp"
          />
          <send-templates-table
            :rows="rows"
            :pagination="pagination"
            @changePage="changePage"
            @select-all-rows="selectAll"
            @search="submit"
          />
        </div>
        <div v-if="step === 2" class="columns large-9">
          <div>
            <div class="heading-step-2">
              {{ $t("templates.template-type", { type: templateType })}}
            </div>
            <div class="sidebar preview-content">
              <div class="preview-template">
                <div class="header-preview">{{ $t("templates.chat") }}</div>
                <div class="preview-text">
                  <img
                    v-if="isImageTemplate"
                    :src="require('@/assets/images/placeholder.png')"
                  />
                  {{ parseText }}
                </div>
                <div class="time-text">
                  {{ today }}
                </div>
              </div>
              <div class="input-labels">
                <div class="heading-labels">{{ $t("templates.params") }}</div>
                <div class="heading-elements">
                  {{$t('templates.element-name')}}
                <div class="heading-element-name">{{templateSelected.element_name}}</div>
                </div>
                <hcc-input
                  v-if="isImageTemplate"
                  :label="$t('templates.url')"
                  v-model.trim="imageURL"
                  requiredInput
                  customClass="input"
                />
                <div v-for="(param, i) in paramsForm" :key="i">
                  <div class="param-container">
                    <div class="params">
                      <hcc-input
                        :label="$t('templates.param') + (i + 1)"
                        :placeholder="'{{' + (i + 1) + '}}'"
                        v-model="params[i]"
                        requiredInput
                        @input="parsedParam($event, i)"
                        customClass="input"
                      />
                      <templates-labels
                        :labels="formattedLabels"
                        :index="i"
                        @select-label="selectedLabel"
                      />
                    </div>
                  </div>
                  <transition name="fade">
                    <p
                      v-if="selectLabels && selectLabels[i]"
                      class="info"
                      style="animation-duration: 0.5s"
                    >
                      <span>{{ $t("templates.chose-label") }}</span>
                      <span class="info__label">{{ selectLabels[i] }}</span>
                      <hcc-button-icon
                        color="alert"
                        size="xs"
                        class="info__button"
                        @click="deleteLabel(i)"
                      >
                        <close-icon />
                      </hcc-button-icon>
                    </p>
                  </transition>
                  <transition name="fade">
                    <div
                      class="label-note"
                      v-if="selectLabels && selectLabels[i]"
                      style="animation-duration: 0.5s"
                    >
                      {{ $t("templates.default-label") }}
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <available-templates v-show="step === 1" :items="templates" />
      <div class="row">
        <div class="columns button-actions">
          <hcc-button v-show="step === 1" :disabled="validStep1" @click="next">
            {{ $t("templates.next") }}
          </hcc-button>
        </div>
        <div class="secondary-actions">
          <div class="back-button">
            <hcc-button variant="outline" v-show="step === 2" @click="prev">
              {{ $t("templates.prev") }}
            </hcc-button>
          </div>
          <div class="send-button">
            <hcc-button
              v-show="step === 2"
              :disabled="btnDisabled"
              @click="send"
            >
              {{ $t("templates.send") }}
            </hcc-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ClientList from '@/components/ClientList.vue';
import AvailableTemplates from '@/components/AvailableTemplates.vue';
import ButtonFilter from '@/components/ButtonFilter.vue';
import Alert from '@/components/Alert.vue';
import UploadFileCsv from '@/components/UploadFileCsv.vue';
import listClientsGql from '@/graphql/queries/listClients.gql';
import listTemplatesGql from '@/graphql/queries/listTemplates.gql';
import campaingByIdGql from '@/graphql/queries/campaigns/byId.gql';
import executeQuery from '@/utils/gql-api';
import { onLogout } from '@/vue-apollo';
import api from '@/api';
import HccButton from '@/components/shared/HccButton/index.vue';
import HccButtonIcon from '@/components/shared/HccButtonIcon/index.vue';
import HccInput from '@/components/shared/HccInput/index.vue';
import SendTemplatesTable from '@/components/SendTemplatesTable.vue';
import Filters from '@/components/Filters.vue';
import TemplatesLabels from './TemplatesLabels.vue';


const redirectUrl = process.env.VUE_APP_REDIRECT_URL ?? 'https://app.heycenter.com';

export default {
  components: {
    ClientList,
    AvailableTemplates,
    ButtonFilter,
    Alert,
    UploadFileCsv,
    HccButton,
    HccButtonIcon,
    HccInput,
    SendTemplatesTable,
    Filters,
    TemplatesLabels,
  },
  data() {
    return {
      showDisplay: ['company', 'campaign', 'channel'],
      currentCampaignId: null,
      currentChannelId: null,
      templates: [],
      data: [],
      pagination: {
        page: 1,
        perPage: 5,
        totalPages: 0,
      },
      search: null,
      step: 1,
      params: [],
      clientParams: [],
      btnDisabled: false,
      maxSendTemplate: 1000,
      labels: [],
      selectLabels: [],
      showCsv: false,
      csv: null,
      rows: [],
      filters: [],
      client: null,
      selectedChannel: null,
      formattedLabels: [],
      imageURL: null,
      isAllSelected: false,
    };
  },
  computed: {
    ...mapState({
      clientList: state => state.template.clientList,
      templateSelected: state => state.template.templateSelected || null,
    }),
    paramsForm() {
      if (this.templateSelected
        && this.templateSelected.settings
        && this.templateSelected.settings.num_params) {
        return !this.isImageTemplate
          ? parseInt(this.templateSelected.settings.num_params, 10)
          : parseInt(this.templateSelected.settings.num_params, 10) - 1;
      }
      return 0;
    },
    parseText() {
      let { text } = this.templateSelected;
      this.allParams.forEach((param, index) => {
        const re = `{{${index + 1}}}`;
        text = text.replace(re, `{{${param}}}`);
      });
      return text;
    },
    today() {
      return this.$moment(new Date())
        .format('hh:mm A');
    },
    validStep1() {
      if ((this.clientList && this.clientList.length !== 0 && this.templateSelected)
        || (this.isAllSelected && this.templateSelected)) {
        return false;
      }
      return true;
    },
    allParams() {
      return this.clientParams.concat(this.params);
    },
    isImageTemplate() {
      return ['tImage', 'video', 'document', 'image'].includes(this.templateSelected.settings.message_type);
    },
    templateType() {
      return this.$t(`templates.${this.templateSelected.settings.message_type}`);
    },
    companyId() {
      return this.filters.companyId;
    },
  },
  watch: {
    filters(newValue) {
      if (!newValue.channelId) {
        this.channel = null;
      }

      if (newValue.campaignId && newValue.channelId) {
        this.reset();
        this.deleteClientsList([]);
        this.getConversations(
          newValue.campaignId,
          newValue.channelId,
        );
        this.currentCampaignId = newValue.campaignId;
        this.currentChannelId = newValue.channelId;
        this.channel = newValue.channelId;
        this.getTemplates();
        this.getLabels();
        this.showCsv = true;
      } else if (newValue.campaignId || newValue.companyId) {
        this.reset();
      }
    },
  },
  methods: {
    ...mapMutations({
      toogleClientList: 'template/toogleClientList',
      toogleAvailableTemplate: 'template/toogleAvailableTemplate',
      deleteClientsList: 'template/deleteClientsList',
      setAlert: 'template/setAlert',
      setClientList: 'template/setClientList',
    }),
    selectAll(event) {
      this.isAllSelected = event;
    },
    reset() {
      this.templates = [];
      this.rows = [];
      this.pagination.page = 1;
      this.search = null;
      this.showCsv = false;
    },
    async getTemplates() {
      this.toogleAvailableTemplate(true);
      this.templates = await executeQuery('listTemplates',
        listTemplatesGql,
        {
          campaign_id: this.currentCampaignId,
          status: 'active',
        });
      this.toogleAvailableTemplate(false);
    },
    async getConversations(campaignId, channelId, page = 1, search = null) {
      this.toogleClientList(true);
      const { data, total } = await executeQuery('listClients',
        listClientsGql,
        {
          company_id: this.companyId,
          channel_id: channelId,
          page,
          perPage: this.pagination.perPage,
          search,
        });
      this.rows = data;
      this.pagination.totalPages = total;
      this.toogleClientList(false);
    },
    async getLabels() {
      const campaing = await executeQuery('campaign',
        campaingByIdGql,
        {
          id: this.currentCampaignId,
        });
      if (campaing) {
        this.labels = campaing.labels;
      }

      this.formattedLabels = this.labels.map((label, i) => ({ id: i, label }));
    },
    changePage(page) {
      if (this.pagination.page !== page) {
        this.pagination.page = page;
        this.getConversations(
          this.currentCampaignId,
          this.currentChannelId,
          page,
        );
      }
    },
    submit(props) {
      this.data = [];
      this.pagination.totalPages = 0;
      this.pagination.page = 1;
      this.getConversations(
        this.currentCampaignId,
        this.currentChannelId,
        this.pagination.page,
        props,
      );
    },
    next() {
      this.step = 2;
    },
    prev() {
      this.params = [];
      this.imageURL = '';
      this.selectLabels = [];
      this.clientParams = [];
      this.step = 1;
    },
    send() {
      this.btnDisabled = true;
      const globalParams = this.params.map((tag, i) => {
        if (this.selectLabels[i]) {
          return `TAG:${this.selectLabels[i]}|${tag}`;
        }

        return tag;
      });

      const clients = this.clientList.map(({ username, params }) => {
        params.push(...globalParams);

        let clientParams;

        if (params.length >= this.paramsForm) {
          clientParams = params.slice(0, this.paramsForm);

          if (this.isImageTemplate) {
            clientParams.push({ file: this.imageURL });
          }
        } else {
          clientParams = null;
        }


        return {
          username,
          params: clientParams,
        };
      });

      if (clients.filter(({ params }) => !params).length > 0) {
        this.setAlert({ status: true, type: 'error', msg: this.$t('templates.alerts.clients-without-params') });
        this.btnDisabled = false; return;
      }

      if (clients.length > this.maxSendTemplate) {
        this.setAlert({
          status: true,
          type: 'error',
          msg: this.$t('alerts.maxTemplate'),
        });
        this.btnDisabled = false;
        return;
      }
      const data = this.preparePayload(clients, globalParams);
      this.btnDisabled = false;
      api.templateSend(data)
        .then((res) => {
          if (res.data && res.data.status) {
            this.prev();
            this.imageURL = null;
            this.deleteClientsList([]);
            this.setAlert({
              status: true,
              type: 'info',
              msg: this.$t('alerts.inProcess'),
            });
          } else {
            this.setAlert({
              status: true,
              type: 'error',
              msg: this.$t('alerts.oops'),
            });
          }
          this.btnDisabled = false;
        })
        .catch((e) => {
          if (e.response && e.response.status === 401) {
            onLogout(this.$apollo.provider.defaultClient);
            window.location.href = redirectUrl;
          }
          this.setAlert({
            status: true,
            type: 'error',
            msg: this.$t('alerts.unexpectedError'),
          });
          this.btnDisabled = false;
        });
    },
    preparePayload(clients, globalParams) {
      if (this.isAllSelected) {
        return {
          template: this.templateSelected.id,
          channel: this.currentChannelId,
          company: this.companyId,
          everyClient: this.isAllSelected,
          clientParams: globalParams,
        };
      }
      return {
        template: this.templateSelected.id,
        channel: this.currentChannelId,
        clients,
      };
    },
    onDeleteClient() {
      if (this.clientList.length === 0) {
        this.prev();
      }
    },
    showReplacedText({ params }) {
      this.clientParams = params;
    },
    selectedLabel(item) {
      this.selectLabels[item.index] = null;
      this.selectLabels.splice(item.index, 1, item.label);
    },
    deleteLabel(index) {
      this.selectLabels.splice(index, 1, null);
    },
    getNumbers(e) {
      this.csv = e.split(/\r?\n/);
      const re = new RegExp(/(\+)?[0-9]{10,15}/);
      const clients = this.csv.filter(number => (re.exec(number)))
        .filter((col) => {
          const [number] = col.split(',');
          return number.length <= 15;
        })
        .map((line) => {
          const [number, ...params] = line.split(',');
          return {
            id: null,
            fullName: null,
            username: number,
            updatedAt: null,
            type: 'csv',
            labels: [],
            params: params || [],
          };
        });
      this.setClientList(clients);
      let msg = `Se encontraron ${clients.length} números válidos `;
      if (clients.length !== this.csv.length) {
        const numberInvalid = this.csv.length - clients.length;
        msg += `y ${numberInvalid} números no son válidos.`;
      }
      this.setAlert({
        status: true,
        type: 'info',
        msg,
      });
    },
    onFiltersChanged(filters) {
      this.filters = filters;
    },
    openReports() {
      const query = {
        companyId: this.companyId,
        campaignId: this.currentCampaignId,
        type: 'ClientesReport',
      };
      this.$router.push({ name: 'reports', params: query });
    },
    parsedParam(value, i) {
      this.params[i] = value.replace(/\s+/g, ' ');
    },
  },
  activated() {
    this.deleteClientsList([]);
  },
  deactivated() {
    this.deleteClientsList([]);
  },
};
</script>

<style scoped lang="scss">
@import "~styles/views/_sendTemplates.scss";
</style>
